import { RandomId } from "@swivl-mono/helpers";
import { AllTables, GenericTableSchemaColumnInterface, NodeData_TableSaveRowNode, NodeInterface } from "@swivl-mono/types";
import { Select, SelectItem, SelectableOption, Switch } from "@swivl-mono/ui";

import { TagInput, TagInputType } from "../../../../../Components/TagInput/TagInput";
import { TablesModel } from "../../../../../Models/Tables/Tables.Model";
import TabNodeLayoutData from "../../NodeLayouts/TabNodeLayoutData";
import InspectorFooter from "../../SidePanel/Inspector/components/InspectorFooter";
import InspectorNodeHeader from "../../SidePanel/Inspector/components/InspectorNodeHeader";
import NodePanel from "../NodePanel";
import "./TableSaveRow.Node.scss";

const TableSaveRow = {
  Type: "tableSaveRow",
  Empty: function () {
    return {
      id: RandomId(6),
      type: TableSaveRow.Type,
      table: "",
      onSaveGoto: null,
      onMissingRequiredFieldGoto: null,
      update: false,
      data: {}
    };
  },

  PlumbData: function (node: NodeInterface) {
    let tabs = [{ title: "Saved", id: "onSaveGoto", source: "onSaveGoto", target: node.onSaveGoto }];
    if (node.table && TablesModel.tableHadRequiredFields(node.table)) {
      tabs.push({ title: "Missing Params", id: "onMissingParamsGoto", source: "onMissingParamsGoto", target: node.onMissingParamsGoto });
    }

    return TabNodeLayoutData({
      node: node,
      label: node.update ? "Update Table Row" : "Table Save Row",
      title: AllTables[node.table] ? AllTables[node.table].name : "NOT SET",
      titleHeight: 45,
      bodyHeight: 20,
      baseWidth: 160,
      tabs: tabs
    });
  },
  //   InspectorPanel: function QuestInspectorPanel(props:any) {
  //     const journeys = QuestsModel.useState(s => s.journeys)
  //     // eslint-disable-next-line react/jsx-pascal-case
  //     return <Table.InternalInspectorPanel {...props} journeys={journeys} />
  //  },

  InspectorPanel: class TableInspectorPanel extends NodePanel {
    constructor(props: any) {
      super(props);
      this.setTable = this.setTable.bind(this);
    }
    setTable(option: SelectableOption) {
      const table = AllTables[option.value];
      if (table) {
        // this.onChange({ target: { name: "table", value: option.value } })

        let node: NodeData_TableSaveRowNode = { ...this.props.node } as NodeData_TableSaveRowNode;
        node.table = option.value;
        node.data = {};

        if (TablesModel.tableHadRequiredFields(option.value)) {
          node.onMissingParamsGoto = node.onMissingParamsGoto || "";
        } else {
          if (node.onMissingParamsGoto) {
            delete node.onMissingParamsGoto;
          }
        }
        for (const columnId in table.mapping) {
          if (Object.prototype.hasOwnProperty.call(table.mapping, columnId)) {
            if (table.mapping[columnId].variable?.length > 0) {
              node.data[columnId] = "#*" + table.mapping[columnId].variable + "*#";
            } else {
              node.data[columnId] = table.mapping[columnId].defaultValue || "";
            }
          }
        }
        node.update = table.shouldUpdate ? true : false;

        this.props.updateNode(node, this.props.node);
      }
    }

    render() {
      const node = this.props.node as NodeData_TableSaveRowNode;

      return (
        <div>
          <div className="panel TableSaveRowPanel">
            <InspectorNodeHeader title="Quest" id={this.props.node.id} />
            <Select
              options={TablesModel.getTablesForBotAsOptions() as SelectItem[]}
              selectedValues={this.props.node.table ? [this.props.node.table] : []}
              hideClear
              onChange={(vals) => this.setTable({ value: vals[0] } as SelectableOption)}
            />
            {node.table &&
              AllTables[node.table] &&
              Object.keys(node.data).map((columnId) => {
                return (
                  <TableSaveRowColumn
                    key={columnId}
                    columnId={columnId}
                    schema={AllTables[node.table!].mapping[columnId]}
                    node={node}
                    onChange={this.onChange}
                  />
                );
              })}

            <label>Update row?</label>
            <Switch name="update" on={node.update ? true : false} onChange={this.onChange} />
            {node.update ? (
              <div className="overwriteText">
                If a row for this user exists, this will change all rows that have data in them. Leave feilds blank to not update.
              </div>
            ) : (
              <div className="overwriteText">This will create a new row each time the user hits this node.</div>
            )}

            <InspectorFooter
              deleteNode={this.deleteNode}
              node={this.props.node}
              duplicateNode={this.props.duplicateNode}
              canDuplicate={this.props.canDuplicate}
            />
          </div>
        </div>
      );
    }
  }
};
export default TableSaveRow;

interface Props {
  node: NodeData_TableSaveRowNode;
  columnId: string;
  schema?: GenericTableSchemaColumnInterface;
  onChange: (e: any) => void;
}
function TableSaveRowColumn(props: Props) {
  const { columnId, schema, node, onChange } = props;

  return (
    <div className="TableSaveRowColumn">
      <div className="heading">
        <div className="name">
          {schema?.name}
          {schema?.isRequired ? "*" : ""}
        </div>
        <div className="columnId">{columnId}</div>
      </div>
      <div className="body">
        <TagInput type={TagInputType.SingleLine} value={node.data[columnId] || ""} onChange={onChange} name={"data." + columnId} />
      </div>
    </div>
  );
}
